export const translations = {
  en: {
    review: {
      reviewPageIntro:
        'Review and edit any personal information that has changed',
      patientFirstName: 'First name',
      patientLastName: 'Last name',
      patientName: 'Name',
      raceEthnicity: 'Race & ethnicity',
      patientHomePhone: 'Home phone',
      patientCellPhone: 'Mobile phone',
      patientWorkPhone: 'Work phone',
      patientEmployerPhone: 'Employer phone',
      patientPhoneNumber: 'Phone number',
      patientEmail: 'Email',
      patientAddressMailing: 'Mailing address',
      patientAddressPhysical: 'Physical address',
      patientDob: 'Date of birth',
      patientRace: 'Race',
      patientReligion: 'Religion',
      patientEthnicity: 'Ethnicity',
      patientMaritalStatus: 'Marital status',
      patientCareProviders: 'Primary care provider',
      patientDependents: 'Dependents',
      patientBreastFeeding: 'Breast feeding',
      patientCovidVaccineInPastFourWeeks: 'Covid vaccine in past four weeks',
      patientPatientInstitutionId: 'Patient institution ID',
      patientMothersFirstName: "Mother's firstName",
      patientUseEmail: 'Use email',
      patientAccommodations: 'Accommodations',
      patientsEnglishFluency: 'English fluency',
      patientHomeless: 'Homeless',
      patientInterpreterNeeded: 'Interpreter needed',
      patientOccupation: 'Occupation',
      patientPhotoIdUpload: 'Identification',
      patientPreferredContactMethod: 'Preferred contact method',
      patientPreferredFirstName: 'Preferred first name',
      patientPreferredLastName: 'Preferred last name',
      patientPreferredLanguage: 'Preferred language',
      patientPreferredPhone: 'Preferred phone',
      patientWrittenLanguage: 'Preferred written language',
      patientEmployer: 'Employer',
      patientSex: 'Sex',
      surgeryName: '{{name}} ({{date}})',
      patientVeteranStatus: 'Veteran status',
      patientVideoVisitCapabilities: 'Video visit capabilities',
      phone: 'Phone',
      guarantorRelationshipToPatient: 'Relationship to patient',
      guarantorSex: 'Sex',
      guarantorEmail: 'Email',
      guarantorMailingAddress: 'Mailing address',
      guarantorPhoneNumber: 'Phone number',
      guarantorNotFound: 'No guarantors found',
      update: 'Update my information',
      continue: 'Continue',
      insuranceProvider: 'Insurance Provider',
      cardCountKey: 'Insurance Card',
      cardCountValue: '{{count}} card on file',
      cardCountValue_plural: '{{count}} cards on file',
      insuranceId: 'Insurance Id ',
      cardNumber: '(Card {{cardNumber}})',
      patientEmploymentStatus: 'Employment status',
      patientEmergencyContact: 'Emergency contact',
      patientGuarantors: 'Person responsible for medical bills',
      personalInformationTitleKey: 'Personal Information',
      pharmacyTitleKey: 'Pharmacy',
      patientCondition: 'Condition',
      primaryCareProviderTitleKey: 'Primary Care Provider',
      allergiesTitleKey: 'Allergies',
      emergencyContactTitleKey: 'Emergency Contact',
      emergencyContactsTitleKey: 'Emergency Contacts',
      familyMedicalHistoryTitleKey: 'Family medical history',
      personalMedicalHistoryTitleKey: 'Personal medical history',
      demographicsTitleKey: 'Demographics',
      careProvidersTitleKey: 'Primary care provider',
      guarantorTitleKey: 'Guarantor',
      insuranceCardsTitleKey: 'Insurance Cards',
      identificationTitleKey: 'Identification',
      additionalInformationTitleKey: 'Additional Information',
      emergencyContactNameLabel: 'Name',
      emergencyContactRelationshipLabel: 'Relationship',
      emergencyRelativeContactRelationshipLabel:
        'Patient relationship to contact',
      emergencyContractPhoneNumberLabel: 'Phone number',
      policyHolderLabel: 'Policy holder',
      memberIdLabel: 'Member ID',
      groupNumberLabel: 'Group number',
      coverageStartDateLabel: 'Coverage start date',
      primaryCareProviderNameLabel: 'Name',
      primaryCareProviderPhoneNumberLabel: 'Phone number',
      primaryCareProviderAddress: 'Address',
      pharmacyAddress: 'Address',
      payingWithInsurance: 'Paying with insurance',
      insuranceCardNamePlaceHolder: 'Insurance Card',
      noInsuranceMessage:
        'No insurance cards on file. Add one today to prevent billing issues.',
    },
  },
  es: {
    review: {
      reviewPageIntro:
        'Revise y edite cualquier información personal que haya cambiado',
      patientFirstName: 'Nombre',
      patientLastName: 'Apellidos',
      patientName: 'Nombre',
      raceEthnicity: 'Raza y origen étnico',
      patientHomePhone: 'Teléfono de casa',
      patientCellPhone: 'Teléfono celular',
      patientWorkPhone: 'Teléfono del trabajo',
      patientEmployerPhone: 'Teléfono del empleador',
      patientPhoneNumber: 'Número de teléfono',
      patientEmail: 'Correo electrónico',
      patientAddressMailing: 'Dirección de envío',
      patientAddressPhysical: 'Dirección física',
      patientDob: 'Fecha de nacimiento',
      patientRace: 'Raza',
      patientReligion: 'Religión',
      patientEthnicity: 'Origen étnico',
      patientMaritalStatus: 'Estado civil',
      patientCareProviders: 'Médico de atención primaria',
      patientDependents: 'Dependientes',
      patientBreastFeeding: 'Lactancia materna',
      patientCovidVaccineInPastFourWeeks:
        'Vacuna Covid en las últimas cuatro semanas.',
      patientPatientInstitutionId: 'ID de la institución del paciente',
      patientMothersFirstName: 'Nombre de la madre',
      patientUseEmail: 'Usar correo electrónico',
      patientAccommodations: 'Comodidades',
      patientsEnglishFluency: 'Fluidez en inglés',
      patientHomeless: 'Sin hogar',
      patientInterpreterNeeded: 'Se necesita intérprete',
      patientOccupation: 'Ocupación',
      patientPhotoIdUpload: 'Identificación',
      patientPreferredContactMethod: 'Método de contacto preferente',
      patientPreferredFirstName: 'Nombre preferente',
      patientPreferredLastName: 'Apellido preferente',
      patientPreferredLanguage: 'Idioma preferente',
      patientPreferredPhone: 'Teléfono preferente',
      patientWrittenLanguage: 'Idioma escrito preferente',
      patientEmployer: 'Empleador',
      patientSex: 'Sexo',
      patientVeteranStatus: 'Condición de veterano',
      patientVideoVisitCapabilities: 'Opciones de visita por vídeo',
      phone: 'Teléfono',
      guarantorRelationshipToPatient: 'Relación con el paciente',
      guarantorSex: 'Sexo',
      guarantorEmail: 'Correo electrónico',
      guarantorMailingAddress: 'Dirección de envío',
      guarantorPhoneNumber: 'Número de teléfono',
      update: 'Actualizar mi información',
      continue: 'Continuar',
      insuranceProvider: 'Proveedor de seguros',
      cardCountKey: 'Tarjeta de seguro',
      cardCountValue: '{{count}} tarjeta registrada',
      cardCountValue_plural: '{{count}} tarjetas registradas',
      insuranceId: 'ID del seguro',
      cardNumber: '(Tarjeta {{cardNumber}})',
      patientEmploymentStatus: 'Estado laboral',
      patientEmergencyContact: 'Contacto de emergencia',
      patientGuarantors: 'Persona responsable de las facturas médicas',
      personalInformationTitleKey: 'Información personal',
      primaryCareProviderTitleKey: 'Médico de atención primaria',
      emergencyContactTitleKey: 'Contacto de emergencia',
      emergencyContactsTitleKey: 'Contactos de emergencia',
      demographicsTitleKey: 'Demografía',
      careProvidersTitleKey: 'Médico de atención primaria',
      guarantorTitleKey: 'Garantía',
      insuranceCardsTitleKey: 'Tarjetas de seguro',
      identificationTitleKey: 'Identificación',
      additionalInformationTitleKey: 'Información adicional',
      emergencyContactNameLabel: 'Nombre',
      emergencyContactRelationshipLabel: 'Relación',
      emergencyRelativeContactRelationshipLabel:
        'Relación del paciente con el contacto',
      emergencyContractPhoneNumberLabel: 'Número de teléfono',
      policyHolderLabel: 'Titular de la póliza',
      memberIdLabel: 'ID de miembro',
      groupNumberLabel: 'Número de grupo',
      coverageStartDateLabel: 'Fecha de inicio de cobertura',
      primaryCareProviderNameLabel: 'Nombre',
      primaryCareProviderPhoneNumberLabel: 'Número de teléfono',
      payingWithInsurance: 'Pagando con seguro',
      insuranceCardNamePlaceHolder: 'Tarjeta de seguro',
      noInsuranceMessage:
        'No hay tarjetas de seguro registradas. Agregue una hoy para evitar problemas de facturación.',
      noEmergencyContacts: 'No emergency contacts',
      addEmergencyContacts: 'Add emergency contacts',
    },
  },
  ru: {
    review: {
      reviewPageIntro:
        'Просмотрите и отредактируйте любую изменившуюся личную информацию.',
      patientEmail: 'Электронная почта',
      patientRace: 'Раса',
      patientEthnicity: 'Этническая принадлежность',
      patientPhotoIdUpload: 'Идентификация',
      patientPreferredFirstName: 'Предпочитаемое имя',
      patientEmployer: 'Работодатель',
      phone: 'Телефон',
      guarantorEmail: 'Электронная почта',
      continue: 'Продолжить',
      personalInformationTitleKey: 'Личные данные',
      emergencyContactTitleKey:
        'Контактное лицо в случае чрезвычайной ситуации',
      demographicsTitleKey: 'Демографические данные',
      identificationTitleKey: 'Идентификация',
      emergencyContactRelationshipLabel: 'Отношения',
    },
  },
  ht: {
    review: {
      reviewPageIntro: 'Revize epi modifye nenpòt enfòmasyon pèsonèl ki chanje',
      patientEmail: 'Imèl',
      patientRace: 'Ras',
      patientEthnicity: 'Orijin Etnik ou',
      patientPhotoIdUpload: 'Idantifikasyon',
      patientPreferredFirstName: 'Prenon ke ou prefere',
      patientEmployer: 'Patwon, Anplwayè',
      phone: 'Telefòn',
      guarantorEmail: 'Imèl',
      continue: 'Kontinye',
      personalInformationTitleKey: 'Enfomasyon pèsonèl',
      emergencyContactTitleKey: 'Kontak Ijans',
      demographicsTitleKey: 'Enfòmasyon demografik',
      identificationTitleKey: 'Idantifikasyon',
      emergencyContactRelationshipLabel: 'Relasyon (kisa moun lan ye pou ou)',
    },
  },
  km: {
    review: {
      patientLastName: 'នាមត្រកូល',
      patientDob: 'ថ្ងៃខែ​ឆ្នាំ​កំណើត',
      continue: 'បន្ត',
    },
  },
  pt: {
    review: {
      reviewPageIntro:
        'Revise e edite quaisquer informações pessoais que tenham sido alteradas',
      patientFirstName: 'Nome',
      patientLastName: 'Sobrenome',
      patientAddressMailing: 'Endereço para correspondência',
      patientDob: 'Data de nascimento',
      patientSex: 'Sexo',
      guarantorSex: 'Sexo',
      guarantorMailingAddress: 'Endereço para correspondência',
      continue: 'Continuar',
      patientEmploymentStatus: 'Situação de emprego',
      personalInformationTitleKey: 'Informações pessoais',
      emergencyContactTitleKey: 'Contatos de emergência',
      demographicsTitleKey: 'Dados demográficos',
      insuranceCardsTitleKey: 'Cartões de seguro',
      emergencyContactRelationshipLabel: 'Parentesco',
    },
  },
  bn: {
    review: {
      reviewPageIntro:
        'কোনো ব্যক্তিগত তথ্য পরিবর্তিত হয়ে থাকলে, সেগুলো পর্যালোচনা ও সম্পাদনা করুন',
      patientFirstName: 'নাম',
      patientLastName: 'পদবি',
      patientAddressMailing: 'চিঠি পাঠানোর ঠিকানা',
      patientSex: 'লিঙ্গ',
      guarantorSex: 'লিঙ্গ',
      guarantorMailingAddress: 'চিঠি পাঠানোর ঠিকানা',
      continue: 'চালিয়ে যান',
      patientEmploymentStatus: 'কর্মসংস্থানের অবস্থা',
      personalInformationTitleKey: 'ব্যক্তিগত তথ্য',
      emergencyContactTitleKey: 'জরুরী যোগাযোগ',
      demographicsTitleKey: 'জনসংখ্যাতত্ত্',
      insuranceCardsTitleKey: 'বীমা কার্ড',
      emergencyContactRelationshipLabel: 'সম্পর্ক',
    },
  },
  ja: {
    review: {
      reviewPageIntro: '変更があった個人情報を確認・編集する',
      patientFirstName: '名',
      patientLastName: '姓',
      patientAddressMailing: '住所',
      patientSex: '性別',
      guarantorSex: '性別',
      guarantorMailingAddress: '住所',
      continue: '続行',
      patientEmploymentStatus: '雇用状況',
      personalInformationTitleKey: '個人情報',
      emergencyContactTitleKey: '緊急連絡先',
      demographicsTitleKey: '人口統計',
      insuranceCardsTitleKey: '保険証',
      emergencyContactRelationshipLabel: '関係',
    },
  },
  ko: {
    review: {
      reviewPageIntro: '검토 및 변경된 개인 정보 편집',
      patientFirstName: '이름',
      patientLastName: '성',
      patientAddressMailing: '우편 주소',
      patientSex: '성별',
      guarantorSex: '성별',
      guarantorMailingAddress: '우편 주소',
      continue: '계속',
      patientEmploymentStatus: '고용 상태',
      personalInformationTitleKey: '개인정보',
      emergencyContactTitleKey: '비상 연락처',
      demographicsTitleKey: '인구통계',
      insuranceCardsTitleKey: '보험 카드',
      emergencyContactRelationshipLabel: '관계',
    },
  },
  ro: {
    review: {
      reviewPageIntro:
        'Examinați și editați orice informații personale care s-au modificat',
      patientFirstName: 'Nume',
      patientLastName: 'Prenume',
      patientAddressMailing: 'Adresa poștală',
      patientSex: 'Sex',
      guarantorSex: 'Sex',
      guarantorMailingAddress: 'Adresa poștală',
      continue: 'Continuare',
      patientEmploymentStatus: 'Statutul de angajare',
      personalInformationTitleKey: 'Informații personale',
      emergencyContactTitleKey: 'Contact de urgență',
      demographicsTitleKey: 'Demografie',
      insuranceCardsTitleKey: 'Carduri de Asigurare',
      emergencyContactRelationshipLabel: 'Relația',
    },
  },
  zh: {
    review: {
      reviewPageIntro: '查看并编辑任何已更改的个人信息',
      patientFirstName: '名字',
      patientLastName: '姓氏',
      patientAddressMailing: '邮寄地址',
      patientSex: '性别',
      guarantorSex: '性别',
      guarantorMailingAddress: '邮寄地址',
      continue: '继续',
      patientEmploymentStatus: '就业状态',
      personalInformationTitleKey: '个人信息',
      emergencyContactTitleKey: '紧急联系人',
      demographicsTitleKey: '人口统计',
      insuranceCardsTitleKey: '保险卡',
      emergencyContactRelationshipLabel: '关系',
    },
  },
};
